export const SIGNIN = "user/sign-in";
export const FORGOTPASSWORD = "user/forget-password";
export const VERIFYPASSWORDOTP = "user/verify-password-otp";
export const RESETPASSWORD = "user/reset-password";
export const VERIFYOTP = "user/verify-otp";
export const GETPANCHAYAT = "admin/get-panchayat";
export const GETPANCHAYATADMIN = "panchayat/get-panchayat-based-admin";
export const GETBOOTHADMIN = "admin/get-booth-based-admin";
export const GETALLVOTERS = "superAdmin/get-all-voters";
export const GETVOTERS = "admin/get-voters";
export const GETVOTERSMESSAGE = "admin/get-voters";

export const GETINFLUENCER = "user/get-influencer";

export const GETBOOTH = "admin/get-booth";
export const GETBOOTHDETAILS = "admin/get-booth-details";
export const ADDVOTERS = "superAdmin/add-voters";
export const ADDVOTER = "superAdmin/add-voter";
export const PANCHAYATDATA = "panchayat/get-panchayat";
export const GETASSEMBLY = "assembly/get-assembly";
export const GETADMINID = "admin/get-admin";
export const ADDPANCHAYAT = "panchayat/add-panchayat";
export const GETADMINPANCHAYAT = "panchayat/get-panchayat";
export const GETALLBOOTHDETAILS = "admin/get-all-booth-details";
export const ADDBOOTH = "admin/add-booth";
export const GETALLASSEMBLY = "assembly/get-all-assembly-details";
export const GETPANCHAYATDETAILS = "/panchayat/get-panchayat-details";
export const ADDASSEMBLY = "assembly/add-assembly";
export const EDITASSEMBLY = "assembly/edit-assembly/";
export const EDITPANCHAYAT = "panchayat/edit-panchayat/";
export const EDITBOOTH = "admin/edit-booth/";
export const ASSEMBLYBASEDADMIN = "assembly/get-assembly-based-admin";
export const PANCHAYATBASEDASSEMBLY = "panchayat/get-panchayat-based-assembly";
export const CONSTITUENCYBASEDADMIN =
  "constituency/get-constituency-based-admin";
export const ASSEMBLYBASEDADMINID = "assembly/get-assembly-based-admin-id/";
export const PANCHAYATBASEDASSEMBLYID =
  "panchayat/get-panchayat-based-admin-id/";
export const CONSTITUENCYBASEDADMINID = "constituency/constituency-summary-id/";
export const ASSEMBLYFROMCONSTITUENCY =
  "assembly/get-assembly-based-constituency";

export const EDITVOTER = "admin/edit-voter/";
export const DELETEVOTER = "superAdmin/delete-voter/";
export const ALLCONSTITUENCY = "constituency/get-all-constituency";
export const ADDCONSTITUENCY = "constituency/add-constituency";
export const CONSTITUENCYDETAILS = "constituency/constituency-summary";
export const EDITCONSTITUENCY = "constituency/edit-constituency/";

export const ALLUSERS = "user/get-all-users";
export const ALLUSERROLES = "user/get-all-roles";
export const ADDUSER = "user/sign-up";
export const BULKUSER = "user/bulk-sign-up";

export const EDITUSER = "user/update-user/";
export const UPLOADBULKCONSTI = "constituency/upload-bulk-constituency";
export const UPLOADBULKASSEMBLY = "assembly/upload-bulk-assembly";
export const UPLOADBULKPANCHAYAT = "panchayat/upload-bulk-panchayat";
export const UPLOADBULKBOOTH = "admin/upload-bulk-booth";
export const ADDINFLUENCER = "superAdmin/influencer-marking/";
export const NEWVOTER = "superAdmin/new-voter/";
export const SENDMESSAGE = "superAdmin/send-message/email";

export const CREATEFORM = "survey/create-survey";
export const GETFORM = "survey/get-all-survey";
export const GETFORMFROMID = "survey/get-survey/";

export const SURVEYSTATUS = "survey/survey-status/";
export const SUBMITSURVEYDATA = "survey/submit-survey-response/";

export const GETDATAFROMSURVEY = "survey/get-survey-response/";

export const CREATEGRIEVANCE = "grievance/create-grievance";
export const UPDATEGRIEVANCE = "grievance/update-grievance";
export const GETGRIEVANCE = "grievance/get-grievance";
export const GETGRIEVANCES = "grievance/get-grievances/";
export const GETGRIEVANCEBYSTATUS = "grievance/get-grievance";

export const GETALLGRIEVANCE = "grievance/get-all-grievance";
export const ASSIGN_GRIEVANCE = "grievance/assign-grievance";
export const GET_ALL_ADMIN = "user/get-all-users";

export const GET_ASSIGNED_GRIEVANCE = "grievance/get-assigned-grievance";
export const GETCONSTITUENCYGREIVANCE = "grievance/get-grievance-constituency/";
export const GETPANCHAYATGREIVANCE = "grievance/get-grievance-panchayat/";
export const UPDATEGREIVANCESTATUS = "grievance/update-grievance-status/";

export const UPLOADPCDETAILS = "booth/add-parliament-election-details";
export const UPLOADACDETAILS = "booth/add-assembly-election-details";

export const CONSTELECTIONDETAILSASSEMBLY =
  "constituency/get-assembly-election-analysis/";
export const CONSTELECTIONDETAILSPARLIAMENT =
  "constituency/get-parliament-election-analysis/";

export const ASSEMBLYELECTIONDETAILSASSEMBLY =
  "assembly/get-assembly-election-analysis/";
export const ASSEMBLYELECTIONDETAILSCONST =
  "assembly/get-parliament-election-analysis/";

export const ASSEMBLYBRIEFPC = "booth/parliament-election-brief";
export const ASSEMBLYBRIEFAC = "booth/election-brief";
export const ASSEMBLYDETAILSDASHBOARD =
  "assembly/assembly-details-for-assembly-dashboard";

export const CONSTITUENCYBRIEFPC = "booth/constituency-brief-parliament";
export const CONSTITUENCYBRIEFAC = "booth/parliament-assembly-brief";

export const VERIFYPHONE = "user/verify-phoneNo";
export const UPLOADPASTDETAILS = "admin/upload-past-election-details";

export const GETPASTELECTIONDETAILS = "admin/get-past-election-details";

export const ASSEMBLYANALYSISAC = "assembly/get-assembly-election-analysis";
export const ASSEMBLYANALYSISPC = "assembly/get-parliament-election-analysis";

export const UPLOADDOC = "grievance/upolad-docs";
export const GRIEVANCEADDRESS = "grievance/admin-Address";

export const APPOINTMENTVERIFYOTP = "appointment/verify-otp";
export const APPOINTMENTGETOTP = "appointment/send-otp";
export const BOOKAPPOINTMENT = "appointment/book-appointment";

export const APPOINTMENTROLES = "user/get-all-roles";
export const APPOINTMENTLEADERS = "appointment/get-leader";
export const APPOINTMENTSLOTS = "appointment/get-appointment-slots";

export const ADMINAPPOINTMENT = "appointment/create-appointment-slot";
export const GETADMINAPPOINTMENT = "appointment/get-appointment-details";

export const BIRTHDAYWISH = "superAdmin/send-message/birthdayEmail";

//event planner

export const FETCHEVENTS = "event/get-event";
export const ADDEVENT = "event/create-event";
export const BULKEVENT = "event/bulk-upload";

export const UPDATEEVENT = "event/update-event";
export const DELETEEVENT = "event/delete-event";

export const FAMILYHEAD = "superAdmin/family-head";

export const ASSEMBLYDASHBOARD = "assembly/get-dashboard-details";
export const CONSTITUENCYDASHBOARD = "constituency/get-dashboard-details";
export const GRAPGHVOTERCONSTITUENCY =
  "constituency/get-constituency-dashboard-details";

export const DRAFT = "grievance/get-draft-grievance";
export const GRAPGHVOTERASSEMBLY = "assembly/get-asssembly-dashboard-details";
export const ABOUTASSEMBLY = "assembly/get-assembly-about";
export const ABOUTCONSTITUENCY = "constituency/get-constituency-about";
export const CONSTGRAPHDETAILS =
  "booth/assembly-Details-for-constituency-dashboard";

export const ABOUTASSEMBLYUPLOAD = "assembly/add-assembly-about";
export const ABOUTCONSTITUENCYUPLOAD = "constituency/add-constituency-about";

export const ASSEMBLYABOUT = "constituency/get-assembly-for-about";
export const ASSEMBLYABOUTBLOCK = "constituency/get-block-for-about";
export const ASSEMBLYABOUTPANCHAYAT = "constituency/get-panchayat-for-about";
export const ASSEMBLYABOUTBOOTH = "constituency/get-booth-for-about";
export const ASSEMBLYABOUTVILLAGE = "constituency/get-village-for-about";

export const ADD_DRIVER ="travel/create-driver";
export const GETALLDRIVER = "travel/all-driver";
export const EDITDRIVER = "travel/update-driver/:id";
export const DELETE_DRIVER = "travel/delete-driver/:id";
export const ADD_VEHICLE = "travel/create-vehicle";
export const GETALLVEHICLE = "travel//all-vehicle";
export const GET_VEHICLE ="travel/vehicle/:id";
export const EDITVEHICLE = "travel/update-vehicle/:id";
export const DELETE_VEHICLE = "travel/delete-vehicle/:id";
export const ADD_TRIP = "travel/create-trip";
export const GETALLTRIP = "travel/all-trips";
export const EDITTRIP = "travel/update-trip/:id";
export const DELETETRIP = "travel/delete-trip/:id";
export const GETTRIP = "travel/get-trip/:id";
export const VEHICLE_ID = "travel/trips/vehicle/"
export const DRIVER_ID = "travel/trips/driver/"
export const DASHBOARD_TRIP = "travel/dashboard-details"
export const TRIPHISTORY = "travel/history"
export const SENDWHATSAPPMESSAGE = "message/send-message"

export const GETDISTRICT = "superAdmin/get-district";
export const GETSUBDISTRICT = "superAdmin/get-sub_district/:id";
export const GETTALUKA = "superAdmin/get-taluka/:id";
export const GET_GP = "superAdmin/get-gp/:id";
export const GET_VILLAGE = "superAdmin/get-village/:id";  
export const GET_ALL_EMPLOYEE ="employee/get-all-employee";
export const CREATE_EMPLOYEE = "employee/enroll-employee";
export const GET_ALL_ASSET = "asset/get-all-asset";
export const ADD_ASSET ="asset/add-asset";
export const EDIT_ASSET = "asset/edit-asset/:id";
export const DELETE_ASSET = "asset/delete-asset/:id";
export const EDIT_EMPLOYEE = "employee/edit-employee/:id";
export const DELETE_EMPLOYEE = "employee/delete-employee/:id";
export const ADD_FEEDBACK = "feedback/add-feedback";
export const GET_FEEDBACK = "feedback/get-all-feedback";
